<template>
    <div class="root flex flex-col border-box flex-wrap">

        <div v-for="item in fileData" style="width: 25%;" class="flex flex-center-sp">
          <div class="file-box">
            <div v-if="item.type == 1" >
            <div class="flex flex-center-sp flex-center-cz pointer" :class="dirBoxClassName" @click="gridItemClick(item.id)" >
              <img style="width: 65px; height: 58px;" src="@/assets/images/folder4.png" :data-id="item.id"/>
            </div>
            <div class="margin-top-s flex flex-space-between" style="height:45px;">
              <div class="file-left">
                <div class="file-name">{{item.name}}</div>
              </div>
              <div class="file-right">
                <div class="file-share pointer cannotselect" @click="share(item)" ><img class="share-img" src="@/assets/images/share.png"/></div>
                <div class="file-more pointer cannotselect"  @click="showMore($event, item.id,item.name)"><img class="more-img" src="@/assets/images/icmore.png" /></div>
              </div>
            </div>  
            <div @click="selectClick(item.id)" class="position-absolute pointer" :class="selectBoxClassName" >
              <img style="width:20px;height:20px" :class="{'yes-select': item.select && editMode,'no-select': !item.select}" />
            </div>     
            </div>
            <div v-if="item.type == 2" >
              <div class="pointer" @click="gridItemClick(item.id)" :class="dirBoxClassName" style="height:170px;overflow: hidden;">
                <img v-if="item.cover != null && item.cover != ''" class="file-img" :src="item.cover" :data-id="item.id"/>
                <div v-if="item.cover == null || item.cover == ''" class="file-img border-box font-s padding-s">{{item.summary}}</div>
              </div>
              <div class="file-desc">
                <div class="file-left">
                  <div class="file-name text-more row1 full-width">{{item.name}}</div>
                  <div class="flex flex-row file-remark">
                    <div class="margin-right-l flex flex-row" style="width:40px"><img class="dianzan-ico" src="@/assets/images/dianzan.png"/><div class="margin-left-m ">{{item.likeCount}}</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="chakan-ico" src="@/assets/images/chakan.png"/><div class="margin-left-m ">{{item.viewCount}}</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="pinglun-ico" src="@/assets/images/pinglun.png"/><div class="margin-left-m ">{{item.commentCount}}</div></div>
                    <div class="margin-right-l flex flex-row" style="width:45px"><img class="shoucang-ico" src="@/assets/images/shoucang.png"/><div class="margin-left-m ">{{item.collectCount}}</div></div>
                  </div>
                </div>
                <div class="file-right">
                  <div class="file-share pointer cannotselect" @click="share(item)"><img class="share-img" src="@/assets/images/share.png"/></div>
                  <div class="file-more pointer cannotselect" @click="showMore($event, item.id, item.name)"><img class="more-img" src="@/assets/images/icmore.png"/></div>
                </div>
              </div>  
              <div @click="selectClick(item.id)" class="position-absolute pointer" :class="selectBoxClassName" >
                <img style="width:20px;height:20px" :class="{'yes-select': item.select && editMode,'no-select': !item.select}" />
              </div>         
            </div>
          </div>
        </div>
        

      <popup-menu ref="child" :menuData="menuData"  @menuClick="menuClick" ></popup-menu>
      <Share :data="shareData" :show="showShare" @close="showShare = false"></Share>
      <Move :dirData="dirData" :show="showMove" @close="showMove = false" @change="dirChange"></Move>
      <div v-if="editMode && selectCount > 0" class="batch-tool-bar position-fixed flex flex-space-between">
          <div class="flex flex-row">
            <div class="font-l color-white margin-right-xl flex flex-center-cz">已选择{{selectCount}}项</div>
            <div class="margin-right-m btn-blue-full flex flex-center-cz flex-center-sp pointer" @click="batchMoveClick">批量移动</div>
            <div class="margin-right-xl btn-red-full flex flex-center-cz flex-center-sp pointer" @click="batchDeleteClick">批量删除</div>
          </div>
          <div class="btn-white-line pointer" @click="cancelClick">取消</div>  
      </div>


    </div>
</template>

<script>
    import PopupMenu from '@/components/popupMenu/PopupMenu' 
    import Share from '@/modules/share/Share'
    import Move from '@/modules/move/Move'
    import {generateTree} from '@/utils/sysData.js'
    import {getShareToken} from '@/utils/sysUtils'
    import {delDoc,updateDoc,getUserDir,changeDir,addDocShare} from '@/api/api.js';
    import MixinDoc from '@/mixin/mixinDoc';
    
    
    export default{
        name:'DocGrid',
        components:{
            PopupMenu,Share,Move
        },
        mixins:[MixinDoc],
        props:{
            fileData:{}
        },
        data() {
            return {
                dirData: null,
                showShare: false, 
                showMove: false,
                editMode: false,
                selectId: null,
                selectName:null,
                selectCount: 0,
                batchMove: false,
                shareData:{},               
                dirBoxClassName: 'dir-box',
                selectBoxClassName: 'select-box',
            }
        },
        methods:{
            selectClick(id) {
  
                this.dirBoxClassName = "dir-box-a";
                this.selectBoxClassName = "select-box-a";
                this.fileData.forEach((i,index) => {
                    if (i.id == id) {
                        i.select = !i.select;
                    }
                }) 
                var selected = this.fileData.filter(function (s) {
                    return s.select; 
                });
                this.selectCount = selected.length;
                
                if (this.editMode && (this.selectCount == 0)) {
                    this.editMode = false;
                    this.dirBoxClassName = "dir-box";
                    this.selectBoxClassName = "select-box";
                    this.fileData.forEach((i,index) => {
                        i.select = false;
                    }) 

                } else {
                    this.editMode = true;
                }
                this.$forceUpdate();
            },
            gridItemClick(id) {
                if (this.editMode) return;
                this.$emit("itemClick", id);
            },
            showMore(event,id, name) {
                this.selectId = id;
                this.selectName = name
                this.$refs.child.show(event);//调用子组件的show方法，用于显示弹出式菜单，引用组件时，需要 ref="child"      
            },                       
            batchMoveClick() {
                getUserDir().then((res) => {
                    if (res.data.success == true) {
                        let data = res.data.result.records;
                        let children = generateTree(data, "0", 2);
                        this.dirData = [{"id":0, "name":"个人空间", "level": 1, "children": children}];
                        this.showMove = true;
                        this.batchMove = true;
                    }
                })
            }, 
            batchDeleteClick() {
                let selected = this.fileData.filter(d=>d.select == true);
                let i = 0;
                selected.forEach(item => {
                    delDoc(item.id).then((res) => {
                        if (res.data.success == true) {   
                            i++;
                        } 
                    })
                });

                this.dirBoxClassName = "dir-box";
                this.selectBoxClassName = "select-box";     
                this.fileData.forEach((i,index) => {
                    i.select = false;
                }) 
                this.editMode = false;    
                this.showMove = false;   
                this.$emit("change"); 
                this.$showToast({msg: '操作成功！' });     


            },
            cancelClick() {
                this.editMode = false;
                this.dirBoxClassName = "dir-box";
                this.selectBoxClassName = "select-box";
                this.fileData.forEach((i,index) => {
                    i.select = false;
                }) 
            },


        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/modules/doc/DocGrid.vue